import { defineStore } from 'pinia'

export const useTokenStore = defineStore('token', {
    state: () => {
        return { accessToken: "", refreshToken: "", user: null }
    },
    actions: {
        getAccessToken() {
            return this.accessToken
        },
        setAccessToken(token) {
            this.accessToken = token;
        },
        getRefreshToken() {
            return this.refreshToken
        },
        setRefreshToken(token) {
            this.refreshToken = token;
        },
        getUser() {
            return this.user
        },
        setUser(user) {
            this.user = user;
        },
        setSession(accessToken, refreshToken, user) {
            this.accessToken = accessToken;
            this.refreshToken = refreshToken;
            this.user = user;
        },
        clear() {
            this.accessToken = "";
            this.refreshToken = "";
            this.user = null;
        },
    },
    persist: true,
})
